import { get, post } from '@/utils/request'



const BASE_URL = '/cmp-doc/data-project';

// 分页获取资料工程列表
export const getDataProjectList = (params: any) => {
  return post(`${BASE_URL}/list`, params, {}, 'document')
}

// 新增资料工程
export const addDataProject = (params: any) => {
  return post(`${BASE_URL}/add`, params, {}, 'document')
}

// 修改资料工程
export const updateDataProject = (params: any, requestId?: any) => {
  return post(`${BASE_URL}/modify${requestId ? `?requestId=${requestId}` : ''}`, params, {}, 'document')
}

// 删除资料工程
export const deleteDataProject = (projectIds: any) => {
  return post(`${BASE_URL}/remove`, projectIds, {}, 'document')
}

// 获取资料工程属性列表
export const getProjectAttrs = (projectId: any) => {
  return get<any>(`${BASE_URL}/attrs`, { projectId }, {}, 'document')
}

// 获取资料工程字段域值列表
export const getProjectFields = (projectId: any) => {
  return get(`${BASE_URL}/project-fields`, { projectId }, {}, 'document')
}

// 设置资料工程字段域值
export const setProjectFieldValue = (params: any) => {
  return post(`${BASE_URL}/project-fields`, params, {}, 'document')
} 

// 根据资料工程ID获取视图信息 
export const getViewByProjectId = (projectId: any) => {
  return get(`/cmp-doc/data-project-view/getViewByProjectId`, { projectId }, {}, 'document')
}


// 申请上传地址
export const applyUploadUrl = (params: any) => {
  return post(`/cmp-doc/upload/query_upload_url`, params, {}, 'document')
}

// 根据ID获取资料工程信息
export const getProjectById = (projectId: any) => {
  return get(`/cmp-doc/data-project/findById`, { projectId }, {}, 'document')
}

// 获取当前用户图片
export const getUserSignImage = (params?: any) => {
  return get(`/cmp-doc/sign-pic/get-sign-pic`, params, {}, 'document')
}